import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const S = {
  wrapper: {
    background: "#fff",
    marginBottom: "15px",
    borderRadius: 12,
    border: "1px solid #F0EEF8",
    padding: "20px 24px",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 20,
    paddingBottom: 14,
    borderBottom: "1px solid #F0EEF8",
  },
  headerTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1A1A2E",
    margin: 0,
    letterSpacing: "-0.01em",
  },
  headerBadge: {
    fontSize: 11,
    fontWeight: 600,
    color: "#6D5BD0",
    background: "#EDE9F8",
    borderRadius: 20,
    padding: "2px 8px",
    letterSpacing: "0.02em",
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: 0,
    position: "relative",
    paddingLeft: 44,
    paddingBottom: 20,
  },
  rowLast: {
    paddingBottom: 0,
  },
  iconWrap: {
    position: "absolute",
    left: 0,
    top: 1,
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    flexShrink: 0,
  },
  iconProject: {
    background: "#FEF3C7",
    border: "1.5px solid #FDE68A",
    color: "#D97706",
  },
  iconTask: {
    background: "#EFF6FF",
    border: "1.5px solid #BFDBFE",
    color: "#2563EB",
  },
  connector: {
    position: "absolute",
    left: 14,
    top: 33,
    width: 1.5,
    bottom: 0,
    background: "#F0EEF8",
  },
  body: {
    flex: 1,
    paddingLeft: 12,
    minWidth: 0,
  },
  bodyText: {
    margin: 0,
    fontSize: 13.5,
    color: "#4B5563",
    lineHeight: 1.55,
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  memberName: {
    fontWeight: 600,
    color: "#1A1A2E",
  },
  actionType: {
    color: "#6B7280",
  },
  entityType: {
    fontWeight: 600,
    color: "#1A1A2E",
  },
  entityName: {
    color: "#6D5BD0",
    fontWeight: 500,
  },
  time: {
    fontSize: 12,
    color: "#9CA3AF",
    marginTop: 3,
  },
  footer: {
    marginTop: 18,
    paddingTop: 14,
    borderTop: "1px solid #F0EEF8",
    textAlign: "center",
  },
  loadMore: {
    fontSize: 13,
    color: "#6D5BD0",
    fontWeight: 500,
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    letterSpacing: "-0.01em",
  },
  empty: {
    textAlign: "center",
    padding: "32px 0",
    color: "#9CA3AF",
    fontSize: 13.5,
  },
};

function GearIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

function PencilIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  );
}

function timeAgo(dateString) {
  if (!dateString) return "";
  const then = new Date(dateString.replace(" ", "T"));
  const diff = Date.now() - then.getTime();
  const mins = Math.floor(diff / (1000 * 60));
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "1d ago";
  return `${days}d ago`;
}

function ProjectRecentActivity({
  activityData = {},
  loading: propLoading = false,
}) {
  console.log("ProjectRecentActivity activityData", activityData);
  const [activities, setActivities] = useState(
    Array.isArray(activityData?.RecentActivity)
      ? activityData.RecentActivity
      : [],
  );
  const [isLoading, setIsLoading] = useState(propLoading);
  const [visibleCount, setVisibleCount] = useState(8);

  useEffect(() => {
    setActivities(
      Array.isArray(activityData?.RecentActivity)
        ? activityData.RecentActivity
        : [],
    );
    setIsLoading(propLoading);
  }, [activityData, propLoading]);

  const visible = activities.slice(0, visibleCount);
  const hasMore = visibleCount < activities.length;

  if (isLoading) {
    return (
      <div style={S.wrapper}>
        <Skeleton height={28} width={160} style={{ marginBottom: 20 }} />
        {[...Array(5)].map((_, i) => (
          <div key={i} style={{ display: "flex", gap: 12, marginBottom: 18 }}>
            <Skeleton circle width={30} height={30} />
            <div style={{ flex: 1 }}>
              <Skeleton height={14} width="80%" style={{ marginBottom: 6 }} />
              <Skeleton height={12} width={60} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  const navigatePage = (guid) => {
    if (!guid?.EntityType) return;
    if (guid?.EntityType?.includes("Task")) {
      window.open(`/Project/Task/Detail/${guid?.GUID}`, "_blank");
      return;
    }
    window.open(`/Project/Detail/${guid?.GUID}`, "_blank");
  };

  return (
    <div className="tm-main-area">
      <div className="og-card-box">
        <div className="ch-box">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6D5BD0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          <h5>Recent Activity</h5>
          {activities.length > 0 && (
            <span style={S.headerBadge}>{activities.length}</span>
          )}
        </div>

        {activities.length === 0 ? (
          <div className="cb-box">No recent activity to show.</div>
        ) : (
          <div className="cb-box mt-3">
            <ul aria-label="Recent activity feed ">
              {visible.map((item, index) => {
                const isLast = index === visible.length - 1;
                const isProject = item.EntityType === "Project";

                return (
                  <li
                    key={`${item.GUID || "item"}-${index}`}
                    style={{ ...S.row, ...(isLast ? S.rowLast : {}) }}
                  >
                    <div
                      style={{
                        ...S.iconWrap,
                        ...(isProject ? S.iconProject : S.iconTask),
                      }}
                      aria-hidden="true"
                    >
                      {isProject ? <GearIcon /> : <PencilIcon />}
                    </div>

                    {!isLast && <div style={S.connector} aria-hidden="true" />}

                    <div style={S.body} className="pl-0">
                      <p style={S.bodyText} className="fs-12">
                        <span style={S.memberName}>{item.MemberName}</span>{" "}
                        <span style={S.actionType}>{item.ActionType}</span>{" "}
                        <span style={S.entityType}>{item.EntityType}</span>{" "}
                        <span
                          style={S.entityName}
                          onClick={() => navigatePage(item)}
                          className="cursor-pointer"
                        >
                          ({item.EntityName})
                        </span>
                      </p>
                      <div style={S.time}>{timeAgo(item.ActivityDate)}</div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {hasMore && (
          <div className="card-footer-bx">
            <Link
              to="/Project/Dashboard"
              className="link-sm"
              aria-label="View all activity"
            >
              <i className="fa-solid fa-list-check"></i> View all activity
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectRecentActivity;
